import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/billing.js'), 'billing.js')
  resolveStoreModules(require('../store/black-list.js'), 'black-list.js')
  resolveStoreModules(require('../store/booking-requests.js'), 'booking-requests.js')
  resolveStoreModules(require('../store/c-notifications.js'), 'c-notifications.js')
  resolveStoreModules(require('../store/catalog.js'), 'catalog.js')
  resolveStoreModules(require('../store/category.js'), 'category.js')
  resolveStoreModules(require('../store/comments.js'), 'comments.js')
  resolveStoreModules(require('../store/dashboardMenu.js'), 'dashboardMenu.js')
  resolveStoreModules(require('../store/favourites.js'), 'favourites.js')
  resolveStoreModules(require('../store/global.js'), 'global.js')
  resolveStoreModules(require('../store/menus.js'), 'menus.js')
  resolveStoreModules(require('../store/news-from-admin.js'), 'news-from-admin.js')
  resolveStoreModules(require('../store/notifications.js'), 'notifications.js')
  resolveStoreModules(require('../store/photobank.js'), 'photobank.js')
  resolveStoreModules(require('../store/pin-board.js'), 'pin-board.js')
  resolveStoreModules(require('../store/profile-schedule.js'), 'profile-schedule.js')
  resolveStoreModules(require('../store/profiles.js'), 'profiles.js')
  resolveStoreModules(require('../store/reviews.js'), 'reviews.js')
  resolveStoreModules(require('../store/sliders.js'), 'sliders.js')
  resolveStoreModules(require('../store/support.js'), 'support.js')
  resolveStoreModules(require('../store/tariffs.js'), 'tariffs.js')
  resolveStoreModules(require('../store/updates.js'), 'updates.js')
  resolveStoreModules(require('../store/video-gallery.js'), 'video-gallery.js')
  resolveStoreModules(require('../store/website-news.js'), 'website-news.js')
  resolveStoreModules(require('../store/manager/balances.js'), 'manager/balances.js')
  resolveStoreModules(require('../store/manager/banners.js'), 'manager/banners.js')
  resolveStoreModules(require('../store/manager/black-list.js'), 'manager/black-list.js')
  resolveStoreModules(require('../store/manager/email-templates.js'), 'manager/email-templates.js')
  resolveStoreModules(require('../store/manager/messages.js'), 'manager/messages.js')
  resolveStoreModules(require('../store/manager/news.js'), 'manager/news.js')
  resolveStoreModules(require('../store/manager/photo-check.js'), 'manager/photo-check.js')
  resolveStoreModules(require('../store/manager/profiles.js'), 'manager/profiles.js')
  resolveStoreModules(require('../store/manager/reports.js'), 'manager/reports.js')
  resolveStoreModules(require('../store/manager/reviews.js'), 'manager/reviews.js')
  resolveStoreModules(require('../store/manager/support.js'), 'manager/support.js')
  resolveStoreModules(require('../store/manager/tariffs.js'), 'manager/tariffs.js')
  resolveStoreModules(require('../store/manager/users.js'), 'manager/users.js')
  resolveStoreModules(require('../store/member/notifications.js'), 'member/notifications.js')
  resolveStoreModules(require('../store/v2/nav.js'), 'v2/nav.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
